import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-kasp-subscritptions',
  templateUrl: './confirm-kasp-subscritptions.component.html',
  styleUrls: ['./confirm-kasp-subscritptions.component.css']
})
export class ConfirmKaspSubscritptionsComponent implements OnInit {

  poReference: string = "";

  constructor(
    private commonService: CommonService,
    public dialogRef: MatDialogRef<ConfirmKaspSubscritptionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  continueSaveSubscription(): void{
    if(!this.poReference){
      this.commonService.showError(".continue", "Please provide PO Reference for this action", "right");
    }else{
      this.dialogRef.close(this.poReference);
    }
  }
  
  onNoClick(): void{
    this.dialogRef.close();
  }
}
